/**
 *
 * App.js
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 *
 */

import React from 'react';
import { Route, Switch } from 'react-router-dom';
import LoadableVisibility from 'react-loadable-visibility/react-loadable';
import { ToastWrap } from '@ts/commons/Toast';
import { ProgressBar } from '@ts/components/PrefetchRoute';
import Header from '@ts/commons/Header';
import Navigation from '@ts/commons/Navigation';
import CartExpireModal from '@ts/commons/CartExpireModal';
import AppHelmet from '@ts/commons/AppHelmet';
import ScrollToTop from '@ts/commons/ScrollToTop';
import ShareThis from '@ts/commons/ShareThis';
import TalkToUs from '@ts/components/TalkToUs';
import { GoogleAuth } from '@ts/components/GoogleAuth';
import { useCookieContext } from '@ts/commons/ContextCookie';
import CookieNotification from '@ts/commons/CookieNotification';
import NotFoundPage from '../NotFoundPage';
import AuthPage from '../AuthPage';
import PageContent, { Loading } from './PageContent';
import routes from './routes';
const Footer = LoadableVisibility({
    loader: () => import('@ts/commons/Footer'),
    loading: Loading,
});

const paths = Object.values(routes);

function App() {
    const { loadingContext } = useCookieContext();

    return (
        <React.Fragment>
            <AppHelmet />
            <ToastWrap />
            <ProgressBar />
            <Switch>
                <Route exact path="/404.html" component={NotFoundPage} />
                <Route exact path="/auth" component={AuthPage} />
                <Route exact path={paths}>
                    <Header />
                    <Navigation />
                    <TalkToUs />
                    <ScrollToTop>
                        <PageContent />
                    </ScrollToTop>
                    {!loadingContext && (
                        <>
                            <Footer />
                            <CookieNotification />
                            <ShareThis />
                            <GoogleAuth />
                            <CartExpireModal />
                        </>
                    )}
                </Route>
                <Route component={NotFoundPage} />
            </Switch>
        </React.Fragment>
    );
}

export default App;
